// src/features/taxContext/taxContextSlice.js
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	currentCustomerId: null,
	currentTaxpayerId: null,
	currentTaxYear: new Date().getFullYear(),
}

const taxContextSlice = createSlice({
  name: 'taxContext',
  initialState,
  reducers: {
    setCurrentCustomerId: (state, action) => {
      const value = Number(action.payload);
      const next = Number.isInteger(value) && value > 0 ? value : null;
      if (state.currentCustomerId !== next) {
        state.currentCustomerId = next;
        state.currentTaxpayerId = null;
      }
    },
    setCurrentTaxpayerId: (state, action) => {
      state.currentTaxpayerId = action.payload ?? null
    },
    setCurrentTaxYear: (state, action) => {
	  state.currentTaxYear = action.payload ?? null
	},
	clearTaxContext: (state) => {
      state.currentTaxpayerId = null
    },
  },
  extraReducers: (builder) => {
    builder.addCase('auth/logOut', () => ({ ...initialState }));
  },
})

export const {
  setCurrentTaxpayerId,
  setCurrentTaxYear,
  clearTaxContext,
  setCurrentCustomerId,
} = taxContextSlice.actions

export default taxContextSlice.reducer

export const selectCurrentTaxpayerId = (state) =>
  state.taxContext.currentTaxpayerId

export const selectCurrentTaxYear = (state) =>
  state.taxContext.currentTaxYear
export const selectCurrentCustomerId = (state) => state.taxContext.currentCustomerId ?? null;
